// Builds the public preview URL for the property detail page on getlost-web.
// Distinct from the share URL (utils/shareUrl.ts): preview uses the property
// UID, not the nano_id, because the web route /:profile/property/:uid
// expects the UUID assigned at first save (see getlost-web/src/App.tsx:29).
// The shortener URL is intentionally out of scope for preview (per the brief).

import type { IProfileV1 } from '../interfaces/user';

type PreviewProfileInput = Pick<IProfileV1, 'id'> & { username?: string | null };

export function getPropertyPreviewUrl(
    profile: PreviewProfileInput | null | undefined,
    uid: string | undefined | null
): string | null {
    if (!profile) return null;
    if (typeof uid !== 'string' || !uid.trim()) return null;
    const rawUsername = profile.username;
    const slug = (typeof rawUsername === 'string' && rawUsername.trim() ? rawUsername : profile.id.toString()).trim();
    if (!slug) return null;
    return `https://app.getlost.me/${slug}/property/${uid}`;
}
